<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import "common/common.css";
</style>



// WEBPACK FOOTER //
// src/App.vue